// src/web/client/src/utils/orderActivity.js
//
// Pure client-side grouping for the Orders-list activity tags: messages
// (from the existing GET /messages) → { [order_id]: { sent, opened } }.
//
// Honesty rules, enforced here and unit-tested:
//  - Only status === 'sent' counts as "sent" — a scheduled/failed message was
//    NOT sent, and counting it would invent activity.
//  - "opened" is counted only among sent messages.
//  - No entry is fabricated: an order with no messages simply has no key.
//
// Message.order_id stores the Order document's _id as a string
// (webhookRoutes writes order._id.toString()), which is exactly the key the
// Orders list rows carry — so lookup is orderActivity[order._id].

export function buildOrderActivity(messages) {
  const map = {};
  for (const m of Array.isArray(messages) ? messages : []) {
    if (!m || !m.order_id) continue;
    if (m.status !== 'sent') continue;
    const entry = map[m.order_id] || (map[m.order_id] = { sent: 0, opened: 0 });
    entry.sent += 1;
    if (m.opened) entry.opened += 1;
  }
  return map;
}
